import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/beginning-balances', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/beginning-balances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/beginning-balances/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/beginning-balances/${data.balance_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/beginning-balances/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getUser = (Options = {}) => {
  return httpClient
    .get('/api/beginning-balances/users', Option)
    .then(response => Promise.resolve(response.data))
}

export const getCurrency = (Options = {}) => {
  return httpClient
    .get('/api/beginning-balances/currencies', Option)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  getUser,
  getCurrency
}
